var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.182,
    height: 41.217,
    viewBox: "0 0 39.182 41.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1598",
    x: 0,
    y: 0,
    width: 39.182,
    height: 41.217,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9666",
    "data-name": "Group 9666",
    transform: "translate(4.5 3.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9662",
    "data-name": "Group 9662",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#Rectangle_1598)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1598-2",
    "data-name": "Rectangle 1598",
    width: 30.182,
    height: 32.217,
    rx: 4,
    transform: "translate(4.5 3.5)",
    fill: "#040227"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10776",
    "data-name": "Path 10776",
    d: "M16.8,8.562a2.793,2.793,0,0,0-2.861,2.715v4.879A2.823,2.823,0,0,0,16.8,18.907a2.791,2.791,0,0,0,2.825-2.751V11.277A2.761,2.761,0,0,0,16.8,8.562Zm0,1.174a1.567,1.567,0,0,1,1.651,1.541v4.879A1.6,1.6,0,0,1,16.8,17.733a1.628,1.628,0,0,1-1.687-1.577V11.277A1.6,1.6,0,0,1,16.8,9.736ZM12.4,16.67a.587.587,0,0,0-.55.77,5.042,5.042,0,0,0,4.292,3.705v4.292a.587.587,0,1,0,1.174,0V21.145a5.043,5.043,0,0,0,4.292-3.705.587.587,0,1,0-1.137-.293,3.864,3.864,0,0,1-7.483,0A.587.587,0,0,0,12.4,16.67Z",
    transform: "translate(-1.63 -1.185)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.8b6fa1b2b41e2dc504168e1c42853c51.svg";
export { ForwardRef as ReactComponent };